var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09636 4.5606C5.00576 3.93365 5.2348 2.68814 4.60794 1.77868C3.98108 0.869217 2.7357 0.640197 1.8263 1.26715C0.916901 1.8941 0.687858 3.13961 1.31472 4.04907C1.94158 4.95853 3.18696 5.18755 4.09636 4.5606Z",
    fill: "#1F2226"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5357 4.29917C4.30105 3.98211 4.66452 3.10463 4.34752 2.33925C4.03052 1.57387 3.15311 1.21043 2.38775 1.52748C1.6224 1.84454 1.25893 2.72202 1.57593 3.4874C1.89292 4.25278 2.77034 4.61622 3.5357 4.29917Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlor);
export default __webpack_public_path__ + "static/media/klor.af7e44ebd0442875081a92c0abb8c192.svg";
export { ForwardRef as ReactComponent };